import { isEmpty } from "ramda";
import { Skeleton, Typography } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { useGetMonthlyInvoiceQuery } from "@/redux/apis/payment/paymentApi";
import { useAppSelector } from "@/redux/hooks";
import { monthlyInvoiceSelector } from "@/redux/slices/payment/selectors";
import { MonthlyInvoiceTable } from "./MonthlyInvoiceTable";
import { useGetMonthlyInvoiceParams } from "./useGetMonthlyInvoiceParams";

export const MonthlyInvoicePanel = () => {
  const { params } = useGetMonthlyInvoiceParams();
  const { isFetching } = useGetMonthlyInvoiceQuery(params, { refetchOnMountOrArgChange: true });
  const items = useAppSelector(monthlyInvoiceSelector);
  const isPayoutHistoryEmpty = isEmpty(items) && !isFetching;

  if (isFetching) return <Skeleton />;

  return (
    <>
      <header className="mb-4 flex flex-col gap-2">
        <Typography variant="h2">Monthly RideMinder Invoices</Typography>
        <Typography variant="paragraph">
          View and download your paid monthly RideMinder fee statements. All invoices shown here have already been paid.
        </Typography>
      </header>
      {isPayoutHistoryEmpty ? (
        <div className="rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray">
          <EmptyState title="Nothing here… yet" description="There are currently no invoices available" />
        </div>
      ) : (
        <>
          <MonthlyInvoiceTable items={items} />
          <MonthlyInvoiceTable.Pagination />
        </>
      )}
    </>
  );
};
